import cookies from './cookies';
import qs from 'qs';

const COOKIE_NAMESPACE = 'SP-S';

const shorthands = {
  loan: 'a',
  quickloan: 'aa',
  consumerloan: 'aaa',
  akasse: 'b',
  broadband: 'c',
  subscription: 'd',
  prepaid: 'e'
};

function parseCookie() {
  if (!__CLIENT__) {
    return {};
  } else {
    try {
      const namespace = cookies.getItem(COOKIE_NAMESPACE);
      return namespace ? qs.parse(namespace) : {};
    } catch (err) {
      if (__DEV__) {
        console.error(err);
      }
      return {};
    }
  }
}

function saveCookie() {
  if (!__CLIENT__) {
    return false;
  }
  const data = qs.stringify(cookieData);
  cookies.setItem(COOKIE_NAMESPACE, data);
}

const cookieData = parseCookie();

// obfuscation
export const LOAN_OBSFUSCATED = 'a';
export const AKASSE_OBSFUSCATED = 'b';
export const BROADBAND_OBSFUSCATED = 'c';
export const SUBSCRIPTION_OBSFUSCATED = 'd';
export const PREPAID_OBSFUSCATED = 'e';

export default {
  get(key) {
    return cookieData[shorthands[key] || key];
  },
  set(key, value) {
    if (!key) {
      if (__DEV__) {
        throw new Error('Key was not set');
      }
      return null;
    }
    cookieData[shorthands[key] || key] = value;
    saveCookie();
  }
};
